export default "__VITE_ASSET__4f568479__"